// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout-module--root--1cm32","main":"Layout-module--main--1OIFf"};